import { render, staticRenderFns } from "./asideMoney.vue?vue&type=template&id=e6236ee2&scoped=true&"
import script from "./asideMoney.vue?vue&type=script&lang=ts&"
export * from "./asideMoney.vue?vue&type=script&lang=ts&"
import style0 from "./asideMoney.vue?vue&type=style&index=0&id=e6236ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6236ee2",
  null
  
)

export default component.exports